import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from "./context/AuthContext";
import HomePage from "./pages/HomePage";
import ListingDetailPage from "./pages/ListingDetailPage";
import CreateListingPage from "./pages/CreateListingPage";
import LoginPage from "./pages/LoginPage";
import MessagesPage from "./pages/MessagesPage";
import FavoritesPage from "./pages/FavoritesPage";
import ProfilePage from "./pages/ProfilePage";
import AlertsPage from "./pages/AlertsPage";
import AlertDetailPage from "./pages/AlertDetailPage";
import WMSLogin from "./pages/WMSLogin";
import WMSDashboard from "./pages/WMSDashboard";
import AboutPage from "./pages/AboutPage";
import AboutEditor from "./pages/AboutEditor";
import { Toaster } from "./components/ui/toaster";

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/listing/:id" element={<ListingDetailPage />} />
              <Route path="/create-listing" element={<CreateListingPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<LoginPage />} />
              <Route path="/messages" element={<MessagesPage />} />
              <Route path="/favorites" element={<FavoritesPage />} />
              <Route path="/alerts" element={<AlertsPage />} />
              <Route path="/alerts/:id" element={<AlertDetailPage />} />
              <Route path="/profile/:userId?" element={<ProfilePage />} />
              <Route path="/wms/login" element={<WMSLogin />} />
              <Route path="/wms" element={<WMSDashboard />} />
              <Route path="/about-us" element={<AboutPage />} />
              <Route path="/wms/about-editor" element={<AboutEditor />} />
            </Routes>
          </BrowserRouter>
          <Toaster />
        </div>
      </AuthProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
